import { useMemo } from 'react'
import { Drawer, Box } from '@mui/material';
import { DataGridPremium, GridColDef, useGridApiRef } from '@mui/x-data-grid-premium';
import StyledBox from '../../common/Components/StyledBox'
import BoxHeader from '../../common/Components/BoxHeader'
import { useFetch, Status } from '../../hooks/useFetch';
import { ILeg } from '@aviation/cabinapp-flightservice-sdk';


export interface IFlightDetails {
    open: boolean;
    flight : ILeg;
    cancelAction: () => void;
}

function FlightDetails(props: IFlightDetails) {
    const apiRef = useGridApiRef();
    const { status, data = [] } = useFetch<Array<any>>(`/api/flights/byleg/${props.flight.FlightDate}/${props.flight.Al}/${props.flight.No}/${props.flight.Dep}/${props.flight.Dest}/crew`);
    
    
    const columns: GridColDef[] = [
        { field: 'LtrCode', headerName: '3LC', minWidth: 120 },
        { field: 'Owner', headerName: 'Airline', minWidth: 120 },
        { field: 'Firstname', headerName: 'Firstname', minWidth: 150 },
        { field: 'Lastname', headerName: 'Lastname', minWidth: 150 },
        { field: 'Function', headerName: 'Function', minWidth: 120 },
    ];

    const rowId = (row : any) => {
        return row.LtrCode;
    }
    const rows = useMemo(() => {
        return data.map(o => {
            return {
                ...o,
                id: rowId(o)
            }
        })
    }, [data]);

    return (
        <Drawer anchor='right' open={props.open} onClose={(e, r) => { props.cancelAction(); }} style={{ maxWidth: '50%' }}>
            <Box style={{ marginTop: 70, paddingLeft: 20, paddingRight: 20 }}>
                <BoxHeader title={'Crew'}>
                    
                </BoxHeader>
            </Box>
            <StyledBox style={{ paddingLeft: 20, paddingRight: 20 }}>
                <DataGridPremium
                    apiRef={apiRef}
                    autoHeight
                    rows={rows}
                    columns={columns}
                    loading={status === Status.Fetching}
                    editMode="row"
                    getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 0 ? `tui-grid-alternate-row` : '' }}
                    // pagination
                    isCellEditable={(params) => false}
                />
            </StyledBox>
            
        </Drawer>
    )
}

export default FlightDetails